import { render } from "./App.vue?vue&type=template&id=42cc0b16&bindings={\"versionTimeout\":\"data\",\"cookieVisible\":\"data\",\"didAutoLogout\":\"options\",\"isAuthenticated\":\"options\",\"initVersionWatcher\":\"options\",\"acceptCookie\":\"options\"}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script